import type { JourneyPhase } from "../../generated-api";

export type MachineState =
  | "booting"
  | "awaiting_input"
  | "awaiting_llm"
  | "running_actions"
  | "error";

export type JourneyPhaseKind = JourneyPhase["kind"];

// Ordered lifecycle of the coach state machine, shown in the info card.
export const JOURNEY_STATES: {
  kind: JourneyPhaseKind;
  label: string;
  description: string;
}[] = [
  {
    kind: "profile_incomplete",
    label: "Profile incomplete",
    description: "We don't know your long-term goal yet. Start by sharing it.",
  },
  {
    kind: "set_targets",
    label: "Set targets",
    description: "Turn your goals into concrete movement targets.",
  },
  {
    kind: "assess_current_condition",
    label: "Assess",
    description: "Test where you are today to get a clear starting point.",
  },
  {
    kind: "generate_program",
    label: "Generate program",
    description: "Targets are set. The coach builds a first program for them.",
  },
  {
    kind: "perform",
    label: "Perform",
    description: "Follow your program and log completions and how it felt.",
  },
  {
    kind: "adjust_program",
    label: "Adjust program",
    description: "Pain or poor performance was logged. Revise the program.",
  },
  {
    kind: "assess_program_outcome",
    label: "Assess program",
    description: "The program period ended. Evaluate progress, then loop back.",
  },
];

export function isJourneyPhaseKind(
  value: string | null,
): value is JourneyPhaseKind {
  return JOURNEY_STATES.some((s) => s.kind === value);
}
